import { render, staticRenderFns } from "./circular-cta.global.vue?vue&type=template&id=7035b8e1&"
import script from "./circular-cta.global.vue?vue&type=script&lang=js&"
export * from "./circular-cta.global.vue?vue&type=script&lang=js&"
import style0 from "./circular-cta.global.vue?vue&type=style&index=0&id=7035b8e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports